import { gql } from '@apollo/client/index.js'

export const GUARANTEE_COPY_PARTIAL = `
guaranteeCopy: json(
  id: "5bXaWtcoGF04HVmWb5Kuoe",
  locale : $locale,
  preview : $preview
) {
  content
}
`
export const GUARANTEE_COPY_QUERY = gql`
query guaranteeCopyQuery($locale : String! $preview : Boolean!){
  ${GUARANTEE_COPY_PARTIAL}
}
`
